//防抖函数
import m from "moment";

export let deBounce = (fn, delay) => {
    let timer = null;
    return function (...args) {
        if (timer) {
            clearTimeout(timer);
        }

        timer = setTimeout(()=> {
            fn(...args);
        }, delay);
    }
}

//节流函数
export let throttle = (fn, delay) => {
    let flag = true;
    return function (...args) {
        if (!flag) return;
        flag = false;
        setTimeout(() => {
            fn(...args);
            flag = true;
        }, delay);
    }
}

//获取Url上参数
export let getUrlParams = (url) => {
    const params = {};
    const query = (url.substr(1)).split("&");
    for (let i = 0; i < query.length; i++) {
        let q = query[i].split('=')
        if (q.length === 2) {
            params[q[0]] = q[1]
        }
    }
    return params
}

//获取时间
export const getDate = (targetDate, addDay) => {
    return addDay ? m (targetDate).add (addDay, "d").format ("YYYY-MM-DD") : m (targetDate).format ("YYYY-MM-DD");
};

//删除数组中的一个元素
export const removeArrayItem = (a, target) => {
    const array = [...a];
    const index = array.indexOf (target);
    if (index > -1) {
        array.splice (index, 1);
        return array;
    } else {
        return array;
    }
};

//获取二级域名前缀
export function getDomain(){
    let href =  window.location.href;
    if(href.indexOf("localhost")!=-1){
         return 'localhost';
    }else{
         return href.split(".")[0].split("//")[1];
    }
 }

 //获取cookie
export function getCookie(name){
    var prefix = name + "="
    var start = document.cookie.indexOf(prefix)
    if (start == -1) {
        return null;
    }
    var end = document.cookie.indexOf(";", start + prefix.length)
    if (end == -1) {
        end = document.cookie.length;
    }
    var value = document.cookie.substring(start + prefix.length, end)
    return decodeURI(value);
}

export function getBinary(file) {
    return new Promise((resolve, reject) => {
      getBase64(file)
        .then((res) => {
          const arr = res.split(",");
          const mime = arr[0].match(/:(.*?);/)[1];
          const bstr = atob(arr[1]);
          let n = bstr.length;
          const u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          return resolve(new Blob([u8arr], {type: mime}));
        })
        .catch(reject);
    });
}

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });
}